/* eslint-disable-next-line no-undef */
const headers = new Headers();
headers.set('Accept', 'application/json');
headers.set('Content-Type', 'application/json');
headers.set('CMC-Api-Key', 'CMC_WEB');
headers.set('CMC-Accept-Version', '1');

const http = {
  api: {
    path: '/dimona-app/api',
  },
  config: {
    mode: 'cors',
    cache: 'default',
    headers: headers,
  },
};

export { http };
